module.exports = __webpack_public_path__ + "static/sport/logo.d82cddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/logo.png
// module id = WA8P
// module chunks = 0